import { render } from "./ParticlesComponent.vue?vue&type=template&id=0cf946b6"
import script from "./ParticlesComponent.vue?vue&type=script&lang=js"
export * from "./ParticlesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__